import {
  breakpointSizes,
  getBreakpointDown,
  getFontCss,
  styleConstants,
} from '@paywithextend/components'
import React, { useState } from 'react'
import HoverableLink from 'src/components/HoverableLink/HoverableLink'
import { css } from 'styled-components'

interface MoreActionsCellProps {
  testId?: string
  mainIcon?: React.ReactElement
  actionIcon?: React.ReactElement
  actionTitle: string
  actionSubtext?: string
  actionOnClick: () => void
}

const MoreActionsCell: React.FC<MoreActionsCellProps> = (props) => {
  const [dropdownOpen, setDropdownOpen] = useState(false)

  return (
    <div
      css={css`
        margin-left: auto;
        ${getBreakpointDown(breakpointSizes.XSM)(css`
          margin-right: 12px;
        `)}
      `}
      onMouseEnter={(): void => {
        setDropdownOpen(true)
      }}
      onMouseLeave={(): void => {
        setDropdownOpen(false)
      }}
    >
      <div
        css={css`
          display: flex;
          justify-content: flex-end;
          align-items: center;
        `}
        data-testid={props.testId}
      >
        {props.mainIcon}
      </div>
      <div>
        {dropdownOpen && (
          <div
            css={css`
              z-index: 1;
              position: absolute;
              right: 0;
              border-radius: 10px;
              display: flex;
              flex-direction: column;
              border: 1px solid ${styleConstants.colors.gray_medium};
              box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.1);
              width: 250px;
              background-color: ${styleConstants.colors.white};
              gap: 8px;
            `}
          >
            <HoverableLink
              css={css`
                display: flex;
                white-space: wrap;
                padding: 12px 20px;
                ${getFontCss(
                  14,
                  styleConstants.colors.red_dark,
                  styleConstants.fontFamilies.regular,
                )};
                align-items: start;
              `}
              ariaLabel={props.actionTitle}
              onClick={(): void => {
                props.actionOnClick && props.actionOnClick()
              }}
            >
              <div
                css={css`
                  display: flex;
                  margin-right: 5px;
                `}
              >
                {props.actionIcon}
              </div>
              <div>
                <div
                  css={css`
                    margin-top: 5px;
                    ${getFontCss(
                      14,
                      styleConstants.colors.red_dark,
                      styleConstants.fontFamilies.regular,
                    )};
                    &:hover {
                      text-decoration: underline;
                    }
                  `}
                >
                  {props.actionTitle}
                </div>
                {props.actionSubtext && (
                  <div
                    css={css`
                      ${getFontCss(
                        12,
                        styleConstants.colors.gray_darkest,
                        styleConstants.fontFamilies.regular,
                      )};
                    `}
                  >
                    {props.actionSubtext}
                  </div>
                )}
              </div>
            </HoverableLink>
          </div>
        )}
      </div>
    </div>
  )
}

export default MoreActionsCell
